import { SITE, GOOGLE_ADS } from "@/lib/siteConfig";

// Build the Calendly URL while PRESERVING all incoming query parameters
// (including Google Ads tracking params such as gclid, utm_source, etc.)
export function buildCalendlyUrl() {
  if (typeof window === "undefined") return SITE.calendlyUrl;

  const incoming = window.location.search; // e.g. "?gclid=...&utm_source=google"
  if (!incoming || incoming === "?") return SITE.calendlyUrl;

  const base = new URL(SITE.calendlyUrl);
  const incomingParams = new URLSearchParams(incoming);
  incomingParams.forEach((value, key) => {
    base.searchParams.set(key, value);
  });
  return base.toString();
}

// Fire the `schedule_consultation_click` conversion event.
// - Always pushes to dataLayer (compatible with GTM if added later).
// - Only sends a Google Ads conversion when REAL IDs have been configured.
export function trackScheduleConsultationClick() {
  if (typeof window === "undefined") return;

  const eventName = GOOGLE_ADS.CONVERSION_EVENT_NAME;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName });

  const hasRealIds =
    typeof window.gtag === "function" &&
    !GOOGLE_ADS.CONVERSION_ID.includes("PLACEHOLDER") &&
    !GOOGLE_ADS.CONVERSION_LABEL.includes("PLACEHOLDER");

  if (hasRealIds) {
    window.gtag("event", "conversion", {
      send_to: `${GOOGLE_ADS.CONVERSION_ID}/${GOOGLE_ADS.CONVERSION_LABEL}`,
    });
    window.gtag("event", eventName);
  }
}
